import { createContext } from "react";

const OperationListContext = createContext<{ quantities: number[] }>({
  quantities: [],
});

export default OperationListContext;
